var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeakRightSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.15918 7.94922C-0.0530796 8.16164 -0.0531781 8.50497 0.15918 8.71582C0.37155 8.92806 0.714908 8.92805 0.925781 8.71582L4.20117 5.44043C4.46911 5.17235 4.61617 4.81694 4.61621 4.4375C4.61621 4.05806 4.46907 3.70267 4.20117 3.43457L0.925781 0.15918C0.713373 -0.0532166 0.370077 -0.0532238 0.15918 0.15918C-0.0532119 0.371581 -0.0532047 0.714882 0.15918 0.925781L3.43457 4.20117C3.56064 4.32769 3.56073 4.54738 3.43457 4.67383L0.15918 7.94922Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakRightSmall);
export default __webpack_public_path__ + "static/media/beak_right_small.d5b9d075f6858499140711dc00837e7d.svg";
export { ForwardRef as ReactComponent };